// extracted by mini-css-extract-plugin
export default {"root":"fSr8t_fSr8t","loginForm":"kr0QY_kr0QY"};